module.exports = {
	/**
	 * @type {string}
	 * @description 首页三张背景图
	 */
	bg1: 'https://www.eason-solo.cn/img/bg1.jpg',
	bg2: 'https://www.eason-solo.cn/img/bg2.jpg',
	bg3: 'https://www.eason-solo.cn/img/bg3.jpg',
	bg3: 'https://www.eason-solo.cn/img/bg4.jpg',
	bg3: 'https://www.eason-solo.cn/img/bg5.jpg',

	/**
	 * @type {string}
	 * @description 首页故障风文字
	 */
	malfunctionText: 'Eason\'s Blog',

	/**
	 * @type {string}
	 * @description kkFileView预览服务地址
	 */
	kkPreviewPath: 'https://www.eason-solo.cn/preview',

	/**
	 * @type {string}
	 * @description API服务器地址
	 */
	apiServer: 'https://www.eason-solo.cn/api/'
}
